import { trackV2 } from 'utils/analytics';

const LANDING_PAGE = 'landing_page';
const PRIVATE_ACTIVITY = 'private_activity';
const MOBILE_REGISTRATION_PAGE = 'mobile_registration';
const REGISTRATION_PAGE = 'registration';

const pageAttrForAnalytics = (page) => {
  switch (page) {
    case LANDING_PAGE:
      return 'home';
    case PRIVATE_ACTIVITY:
      return 'referral';
    case MOBILE_REGISTRATION_PAGE :
    case REGISTRATION_PAGE:
      return 'register';
    default:
      return '';
  }
};

const track = (attrs) => {
  trackV2({
    category: 'onboarding',
    ...attrs,
    properties: {
      ...attrs.properties
    }
  });
};

// Get background CSS class added to html element, e.g. 'background-7' for use in analytics. Ref: https://strava.atlassian.net/browse/ACQN-141
const getBackgroundName = () => {
  const classList = document.querySelector('html')?.classList;
  return classList
    ? Array.from(classList).find((item) => item.includes('background-')) || null
    : null;
};

export {
  LANDING_PAGE,
  PRIVATE_ACTIVITY,
  MOBILE_REGISTRATION_PAGE,
  REGISTRATION_PAGE,
  pageAttrForAnalytics,
  track,
  getBackgroundName
};
